module.exports = __webpack_public_path__ + "img/file-zip-fill.8e55273b.svg";